import {PlusOutlined} from '@ant-design/icons'
import {Button, Modal, Tag, Upload, UploadFile, UploadProps} from 'antd'
import type {RcFile} from 'antd/es/upload'
const {CheckableTag} = Tag
import React, {useState} from 'react'
import {DatabasePlantRecordMetadata} from '../../entities/plant'
import './ImageUpload.less'

export type ImageUploadProps = {
  fileList?: any
  onChange?: any
  addable: boolean
  disabled?: boolean
  tagFilters?: boolean
}

// const filters = Object.fromEntries(
//   Object.entries(DatabasePlantRecordMetadata)
//     .filter(([key, meta]) => meta.type === 'photo')
//     .map(([key, meta]) => [key, false])
// )

// filters.user = false

export function ImageUpload(props: ImageUploadProps) {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const filters = Object.fromEntries(props.fileList?.map((file) => [file.photoType, false]) || [])
  const [viewedTypesOfEvents, setViewedTypesOfEvents] = useState(filters)
  const noFiltersSelected = Object.values(viewedTypesOfEvents).every((type) => type === false)

  const handleCancel = () => setPreviewOpen(false)

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      return
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1))
  }

  const uploadButton = (
    <div>
      <PlusOutlined rev={undefined} />
      <div style={{marginTop: 8}}>Upload</div>
    </div>
  )

  return (
    <div>
      {props.tagFilters ? (
        <div>
          {Object.entries(filters).map(([key]) => (
            <CheckableTag
              key={key}
              checked={viewedTypesOfEvents[key]}
              onChange={(checked) =>
                setViewedTypesOfEvents((current) => ({...current, [key]: checked}))
              }
            >
              {key}
            </CheckableTag>
          ))}

          <Button
            onClick={async () => {
              setViewedTypesOfEvents(filters)
            }}
            type="primary"
          >
            Reset filters
          </Button>
        </div>
      ) : (
        <></>
      )}
      <Upload
        beforeUpload={() => false}
        fileList={props.fileList?.filter(
          (event) => viewedTypesOfEvents[event.photoType] || noFiltersSelected
        )}
        onChange={props.onChange}
        listType="picture-card"
        onPreview={handlePreview}
        disabled={props.disabled}
        className={!props.addable && 'upload-not-addable'}
      >
        <div>{uploadButton}</div>
      </Upload>
      <Modal open={previewOpen} title={null} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{width: '100%'}} src={previewImage} />
      </Modal>
    </div>
  )
}
